import { useEffect } from "react";

const PaymentEditor = (props) => {
    const { onChangeValid } = props;

    useEffect(() => {
        onChangeValid && onChangeValid(true);
    });

    return "Price editor"
}

export default PaymentEditor;